export default __webpack_public_path__ + "static/media/Jane.b671ce16.png";